import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import ClientesLayout from './clientesLayout';
import ClientTable from './clientTable';
import EditClientModal from './editClientModal';
import DeleteClientModal from './deleteClientModal';

/**
 * Componente principal para a gestão de clientes.
 */
function Clientes() {
    const [authenticated, setAuthenticated] = useState(false);
    const [userData, setUserData] = useState(null);
    const [clients, setClients] = useState([]);
    const [editClient, setEditClient] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [deleteClientId, setDeleteClientId] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    useEffect(() => {
        axios.post('/api/auth', null, { withCredentials: true })
            .then((response) => {
                if (response.data.status === 200) {
                    setAuthenticated(true);
                    setUserData(response.data.user);
                    setClients(response.data.cliente);
                } else {
                    window.location = '/login';
                }
            })
            .catch(() => {
                window.location = '/login';
            });
    }, []);

    if (!authenticated) {
        return (
            <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh"
            }}>
                <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    }

    /**
     * Remove um cliente específico.
     * @param {number|string} id - ID do cliente a ser removido.
     */
    const removeClient = async (id) => {
        try {
            const response = await axios.post(`/api/remove/client/${id}`, null, { withCredentials: true });
            if (response.data.status === 200) {
                // Atualiza a lista de clientes sem recarregar a página
                setClients(prevClients => prevClients.filter(client => client.id !== id));
                setShowDeleteModal(false);
            } else {
                alert(response.data.msg);
            }
        } catch (error) {
            console.error('Erro ao remover o cliente:', error);
            alert('Erro ao remover o cliente');
            window.location = '/bad/request';
        }
    };

    /**
     * Salva as alterações de um cliente específico.
     * @param {number|string} id - ID do cliente a ser editado.
     * @param {string} razao - Nova razão social do cliente.
     */
    const saveClient = async (id, razao) => {
        try {
            const response = await axios.post(`/api/update/client/${id}`, { razao }, { withCredentials: true });
            if (response.data.status === 200) {
                // Atualiza a lista de clientes com as novas informações
                setClients(prevClients => prevClients.map(client => 
                    client.id === id ? { ...client, razao } : client
                ));
                setShowEditModal(false);
            } else {
                alert(response.data.msg);
            }
        } catch (error) {
            console.error('Erro ao salvar o cliente:', error);
            alert('Erro ao salvar o cliente');
            window.location = '/bad/request';
        }
    };

    /**
     * Abre o modal de edição para um cliente específico.
     * @param {number|string} id - ID do cliente a ser editado.
     */
    const handleEdit = (id) => {
        const client = clients.find(c => c.id === id);
        setEditClient(client);
        setShowEditModal(true);
    };

    /**
     * Abre o modal de remoção para um cliente específico.
     * @param {number|string} id - ID do cliente a ser removido.
     */
    const handleDelete = (id) => {
        setDeleteClientId(id);
        setShowDeleteModal(true);
    };

    // Definição das colunas para a tabela de clientes
    const columns = [
        { field: 'id', headerName: '#', width: 70 },
        { field: 'nome', headerName: 'Nome', width: 200 },
    ];

    return (
        <ClientesLayout>
            <div className="row center-element">
                <h1>Consultar Clientes</h1>
            </div>
            <div id='erros'></div>
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <ClientTable 
                                rows={clients} 
                                columns={columns} 
                                onEdit={handleEdit} 
                                onDelete={handleDelete} 
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/* Modal de Edição de Cliente */}
            {editClient && (
                <EditClientModal
                    show={showEditModal}
                    handleClose={() => setShowEditModal(false)}
                    handleSave={saveClient}
                    clientData={editClient}
                />
            )}
            {/* Modal de Remoção de Cliente */}
            {deleteClientId && (
                <DeleteClientModal
                    show={showDeleteModal}
                    handleClose={() => setShowDeleteModal(false)}
                    handleDelete={() => removeClient(deleteClientId)}
                />
            )}
        </ClientesLayout>
    );
}

export default Clientes;
